import styled from 'styled-components';
import { breakpoints } from '../../../styles/breakpoints';

interface StyledLocoBingoLayoutProps {
    isPreview?: boolean;
}

const bundleSizes = {
    mobile: '186px',
    desktop: '194px'
};

export const StyledTwoInARowLayout = styled.div<StyledLocoBingoLayoutProps>`
  &.bundles_layout__two-in-row {
    justify-content: center;

    .bundle {
      margin-right: 0;
    }
  }

  .bundle {
    height: ${bundleSizes.mobile};
    width: ${bundleSizes.mobile};
  }

  @media (min-width: ${breakpoints.tablet}) {
    max-width: 606px;

    &--ios13 {
      max-width: 618px;
      gap: 0;

      .bundle {
        margin-right: 12px;
      }
    }

    justify-content: center;
    gap: ${({ isPreview }) => (isPreview ? 0 : '12px')};
  }

  @media (min-width: ${breakpoints.desktop}) {
    max-width: ${({ isPreview }) => (isPreview ? '344px' : '812px')};
    justify-content: center;

    &--ios13 {
      max-width: 824px;
    }

    .bundle {
      flex: ${({ isPreview }) =>
              isPreview ? 'none' : '0 0 calc(25% - 16px)'};
      height: ${({ isPreview }) => (isPreview ? '166px' : '194px')};
      max-width: ${({ isPreview }) =>
              isPreview ? '166px' : '194px'};
      margin: ${({ isPreview }) => isPreview && '0 0 12px 0'};
      min-width: ${({ isPreview }) => (isPreview ? 0 : '194px')};

      .internal-bundle {
        height: ${({ isPreview }) => isPreview && '166px'};
        width: ${({ isPreview }) => isPreview && '166px'};

        .container .product {
          height: ${({ isPreview }) => isPreview && '166px'};

          .image-container {
            height: ${({ isPreview }) => isPreview && '164px'};
            width: ${({ isPreview }) => isPreview && '164px'};
          }
        }
      }
    }
  }
}
`;
